import React from "react";

export default function SQLServer_SYSDATETIME() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SYSDATETIME</h1>
      <p>This is the SQLServer_SYSDATETIME component generated from the SQL JSON.</p>
    </div>
  );
}
